var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import { Select } from '@mui/material';
import styledMui from '@mui/material/styles/styled';
/**
 * Container for pagination controls
 * Displays pagination and page size selector in a row
 */
export var PaginationContainerStyled = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 24px 16px 24px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 24px 16px 24px;\n"
    /**
     * Container for page size selector
     * Displays label and select input in a row
     */
])));
/**
 * Container for page size selector
 * Displays label and select input in a row
 */
export var LimitContentStyled = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 16px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 16px;\n"
    /**
     * Styled select component for page size selection
     * Customizes the MUI Select component with consistent styling
     */
])));
/**
 * Styled select component for page size selection
 * Customizes the MUI Select component with consistent styling
 */
export var SelectStyled = styledMui(Select)(function (_a) {
    var theme = _a.theme;
    return ({
        '&.MuiInputBase-root': {
            width: '80px',
            height: '40px',
            backgroundColor: 'transparent',
            borderRadius: '12px',
            border: "1px solid ".concat(theme.palette.grey[300]),
            padding: '0px 8px',
            '&:hover': {
                borderColor: theme.palette.primary.main
            },
            '&.Mui-focused': {
                borderColor: theme.palette.primary.main
            }
        },
        '& .MuiSelect-select': {
            height: 'fit-content',
            padding: '8px 12px'
        }
    });
});
var templateObject_1, templateObject_2;
